<script>
  import { getContext } from "svelte";
  import ButtonLabel from '#lib/ButtonLabel.svelte';
  let entry_api = getContext("entry_api");
  import t from "#lib/i18n.svelte.js";
  let site_settings = getContext("site_settings");

  let {
    class: css_class 
  } = $props()
</script>

<button
  class='cancel-tool {css_class}'
  onclick={() => entry_api.cancel_editing()}
  disabled={entry_api?.is_processing}
  title={t('cancel')}
  style='--button-outer-block-spacing: var(--default-button-outer-block-spacing)'
>
  <ButtonLabel variant='brand subtle-outlined text-compact'>{t('cancel')}</ButtonLabel>
</button>
